import "../Styles/MainPage.css";
import { Link } from "react-router-dom";
import { useContext, useEffect } from "react";
import { useParams, generatePath } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../store/action/language/language";
import { useDispatch, useSelector } from "react-redux";
import { BackgroundImage } from "react-image-and-background-image-fade";

function FoodItem(props) {
  let history = useNavigate();
  const { t, i18n } = useTranslation();
  const languageState = useSelector((state) => state.language);
  const dispatch = useDispatch();

  const id = props.id;
  //on clicking on an item user is redirected to /meals with meal id as params
  const handleProceed = (e) => {
    if (!props.active) return;
    history(generatePath("/meals/:id", { id }));
  };

  //used to get language and direction
  useEffect(() => {
    const data = window.localStorage.getItem("LANGUAGE");

    if (data !== null) {
      i18n.changeLanguage(JSON.parse(data).language);
      document.getElementById("root").style.direction = JSON.parse(data).x;
      const { language, x } = JSON.parse(data);
      dispatch(setLanguage(language, x));
    }
  }, [dispatch]);

  return (
    <div
      style={
        i18n.language == "ar" || i18n.language == "ur"
          ? props.active
            ? { direction: "ltr", cursor: "pointer" }
            : { direction: "ltr", cursor: "not-allowed" }
          : props.active
          ? { direction: "rtl", cursor: "pointer" }
          : { direction: "rtl", cursor: "not-allowed" }
      }
      onClick={handleProceed}
      className="col-md-6"
    >
      <div className=" removePadd">
        <div className="mmFoodItem row">
          <div className="col-7">
            <div className="wrapText">
              <p
                style={
                  languageState.lang == "en" || languageState.lang == "id"
                    ? { textAlign: "left" }
                    : null
                }
                className="mmName"
              >
                {props.name}
              </p>
            </div>
            <div
              className={
                languageState.lang == "en" || languageState.lang == "id"
                  ? "enwrapText2"
                  : "wrapText2"
              }
            >
              <p
                style={
                  languageState.lang == "en" || languageState.lang == "id"
                    ? { textAlign: "left" }
                    : null
                }
                className="mmDetails"
              >
                {props.des}
              </p>
            </div>
            <div className="mmBottom">
              <p
                style={
                  languageState.lang == "en" || languageState.lang == "id"
                    ? { direction: "ltr", textAlign: "left" }
                    : { direction: "rtl" }
                }
                className="mmPrice"
              >
                {props.price}{" "}
                {localStorage.getItem("countryId") === "1" ? (
                  <span className="icon-saudi_riyal"></span>
                ) : (
                  props.currency
                )}
              </p>
            </div>
          </div>
          <div className="col-5 center" style={{ position: "relative" }}>
            {/*   <div  className='foodItemImg' style={{ backgroundImage: `url(${props.image})` }}>
</div>*/}

            <BackgroundImage
              src={props.image}
              width="100%"
              className="foodItemImg"
            />
            <div
              onClick={handleProceed}
              style={{
                position: "absolute",
                bottom: "08px",
                right: i18n.language === "ar" || i18n.language === "ur" ? "8px" : "auto",
                left: i18n.language === "en" || i18n.language === "id" ? "8px" : "auto",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "white",
                border: "1px solid #E9E2E3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: props.active ? "pointer" : "not-allowed",
                zIndex: 10,
                pointerEvents: props.active ? "auto" : "none",
              }}
            >
              <span style={{ 
                color: "#E57200", 
                fontSize: "20px", 
                fontWeight: "600", 
                lineHeight: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingBottom: "2px",
                padding: "0",
                margin: "0"
              }}>+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FoodItem;
